import { REPORT_STATUS } from './format';

export const findingCount = (doc) => (doc?.repairs?.length || 0)
  + (doc?.cleanliness?.rating === 'dirty' ? 1 : 0)
  + (doc?.damages_notes?.trim() ? 1 : 0);

export const inspectorName = (doc) => doc?.inspected_by?.name
  || doc?.history?.find(event => event.action === 'created')?.by?.name || '';

export const unitStatus = (doc) => {
  if (!doc) return { label: 'Not Started', tone: 'neutral', icon: 'clock' };
  if (doc.status === 'completed') return { label: 'Completed', tone: 'success', icon: 'check-circle' };
  if (doc.status === 'cancelled') return { label: 'Cancelled', tone: 'neutral', icon: 'slash' };
  if (doc.status !== 'draft' && findingCount(doc)) return { label: 'Issues Found', tone: 'danger', icon: 'alert-triangle' };
  return { label: 'In Progress', tone: 'blue', icon: 'refresh-cw' };
};

export const nextStep = (doc) => {
  if (!doc) return { label: '?', tone: 'neutral' };
  const steps = {
    draft: ['Review findings', 'blue'],
    submitted: [findingCount(doc) ? 'Request quote' : 'Review inspection', 'warning'],
    vendor_assigned: ['Awaiting quotes', 'blue'],
    quote_received: ['Review quotes', 'warning'],
    approved: ['Confirm repairs', 'blue'],
    completed: ['Completed', 'success'],
    cancelled: ['Start new inspection', 'neutral'],
  };
  const [label, tone] = steps[doc.status] || [REPORT_STATUS[doc.status]?.label || doc.status, 'neutral'];
  return { label, tone };
};

const realName = value => typeof value === 'string' && !['', 'n/a', 'na', 'none', 'null', 'undefined', 'vacant', '-'].includes(value.trim().toLowerCase());
export const unitResidentNames = unit => {
  const names = Array.isArray(unit?.residentContacts) ? unit.residentContacts.map(person => person.name)
    : Array.isArray(unit?.residents) ? unit.residents : [unit?.tenant];
  return [...new Set(names.filter(realName).map(name => name.trim()))];
};

export const buildUnitRows = (units, items) => {
  const grouped = new Map();
  units.forEach(unit => grouped.set(String(unit.unitNo), []));
  items.forEach(doc => {
    const key = String(doc.unit_number);
    if (!grouped.has(key)) grouped.set(key, []);
    grouped.get(key).push(doc);
  });
  return [...grouped].map(([unit, docs]) => {
    docs.sort((a, b) => (Date.parse(b.createdAt || b.updatedAt) || 0) - (Date.parse(a.createdAt || a.updatedAt) || 0));
    const details = units.find(row => String(row.unitNo) === unit);
    return { unit, docs, doc: docs[0], residents: unitResidentNames(details).join(', '), residentContacts: details?.residentContacts || [], notices: details?.notices || null };
  });
};

export const csvCell = value => {
  const text = String(value ?? '');
  const safe = /^[=+@\-\t\r]/.test(text) ? `'${text}` : text;
  return `"${safe.replace(/"/g, '""')}"`;
};
